import { TranslationOptions } from 'owa-outlook-service-options';
import { TranslationMode } from 'owa-translation/lib/schema/TranslationMode';
import getTranslationOptions from 'owa-translation/lib/utils/getTranslationOptions';

export default function shouldTranslateAutomatic(locale: string): boolean {
    const options: TranslationOptions = getTranslationOptions();
    return (
        options.translationMode === TranslationMode.Automatic &&
        !options.excludedLanguages.includes(locale)
    );
}
